import * as yup from 'yup';
import { ValidationMessages } from 'shared/models/Validation';

export const loginValidationSchema = yup.object().shape({
    username: yup.string().required(ValidationMessages.REQUIRED),
    password: yup.string().required(ValidationMessages.REQUIRED),
});
